module.exports = __webpack_public_path__ + "img/ssl.8c40ce1.svg";